import config from "@/config";
const contentful = require("contentful");

const client = contentful.createClient({
  space: config.contentful.spaceID,
  accessToken: config.contentful.serviceToken,
});

export default client;